export const shuffleArray = (array: any[]) => {
  let shuffled = array
    .map((a: any) => ({ sort: Math.random(), value: a }))
    .sort((a: any, b: any) => a.sort - b.sort)
    .map((a: any) => a.value);
  return shuffled;
};
